<template>
  <component
    :is="tag"
    :type="tag === 'button' ? type : undefined"
    :disabled="disabled || loading"
    :class="buttonClasses"
    v-bind="$attrs"
  >
    <span v-if="loading" class="inline-flex shrink-0">
      <svg class="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
      </svg>
    </span>
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  inheritAttrs: false,
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: (v) => ['primary', 'secondary', 'ghost', 'danger', 'outline'].includes(v),
    },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md', 'lg'].includes(v),
    },
    type: { type: String, default: 'button' },
    tag: { type: String, default: 'button' },
    disabled: Boolean,
    loading: Boolean,
    block: Boolean,
  },
  computed: {
    buttonClasses() {
      const base =
        'inline-flex items-center justify-center gap-2 font-medium transition-all duration-200 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98]'
      const sizes = {
        sm: 'text-sm px-3 py-1.5',
        md: 'text-sm px-4 py-2.5',
        lg: 'text-base px-6 py-3',
      }
      const variants = {
        primary: 'bg-primary text-white hover:bg-primary-hover shadow-soft',
        secondary: 'glass-subtle text-foreground hover:bg-white/50 dark:hover:bg-white/10 border border-white/50 dark:border-white/10',
        ghost: 'text-muted hover:text-foreground hover:bg-border-subtle',
        danger: 'bg-danger text-white hover:opacity-90',
        outline: 'border border-border text-foreground hover:bg-border-subtle',
      }
      return [base, sizes[this.size], variants[this.variant], this.block && 'w-full']
    },
  },
}
</script>
